import React, { Suspense } from 'react';
import './App.css';

const Navigation = React.lazy(() => import('./components/Navigation'));
const Hero = React.lazy(() => import('./components/Hero'));
const About = React.lazy(() => import('./components/About'));
const Projects = React.lazy(() => import('./components/Projects'));
const TechStack = React.lazy(() => import('./components/TechStack'));
const Contact = React.lazy(() => import('./components/Contact'));

const Loader = () => (
  <div className="loader-container">
    <div className="loader"></div>
  </div>
);

function App() {
  return (
    <div className="App bg-black">
      <Suspense fallback={<Loader />}>
        <Navigation />
        <Hero />
        <About />
        <Projects />
        <TechStack />
        <Contact />
      </Suspense>
    </div>
  );
}

export default App;
